/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function dateTwoDigitFilter($filter: any): any {
        const filter = (input: any) => {
            let output = "";
            if (!input) {
                return output;
            }

            if (input.toString().length === 1) {
                output = "0" + input.toString();
            } else {
                output = input.toString();
            }
            return output;
        }

        return filter;
    }
 
    dateTwoDigitFilter.$inject = ['$filter'];

    angular.module("meevo.components.filters")
        .filter("dateTwoDigit", dateTwoDigitFilter)
}
